import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../../utils/const";
import { useFormik } from "formik";
import { resumeStatusChangeAdd } from "../../../redux/candidate/candidateSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getProfile } from "../../../redux/profile/profileSlice";
import { Button, Grid, MenuItem, TextField } from "@mui/material";
import { Box } from "@mui/system";
import * as Yup from "yup";
import styles from "../Candidate.module.css";

const offer_name = [
  {
    value: "Yes",
    label: "Yes ",
  },
  {
    value: "No",
    label: "No",
  },
];

const StatusChangeDrawer = ({
  handleClose,
  show,
  row,
  singleCandidateStatus,
}) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile.data);

  const formik = useFormik({
    initialValues: {
      reason_for_status_change: "",
      job_title: "",
      duration: "",
      recruiter_name: "",
      company: "",
      notes: "",
    },
    validationSchema: Yup.object({
      reason_for_status_change: Yup.string().required(
        "Reason for status change is required"
      ),
      job_title: Yup.string().required("Job Role is required"),
      duration: Yup.string().required("Duration is required"),
      recruiter_name: Yup.string().required("Recruiter Name is required"),
      company: Yup.string().required("Company is required"),
    }),
    onSubmit: (values) => {
      let userData = {
        active: false,
        resume_profile: row?.id,
        reason_for_status_change: values?.reason_for_status_change,
        job_title: values?.job_title,
        duration: values?.duration,
        company: values?.company,
        recruiter_name: values?.recruiter_name,
        notes: values?.notes,
      };
      dispatch(resumeStatusChangeAdd(userData));
    },
  });

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    if (singleCandidateStatus === "add_resume_status_add_success") {
      formik.resetForm({
        values: {
          reason_for_status_change: "",
          duration: "",
          notes: "",
        },
      });
    }
  }, [singleCandidateStatus]);

  useEffect(() => {
    if (profile) {
      formik.setFieldValue("recruiter_name", profile?.profile?.full_name);
      formik.setFieldValue("company", profile?.profile?.company_name);
    }
  }, [profile]);

  useEffect(() => {
    if (row) {
      formik.setFieldValue("job_title", row?.current_job_title);
    }
  }, [row]);

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "40%",
        backgroundColor: "#f9f9f9",
        borderRadius: "10px 0 0 10px",
        boxShadow: "-4px 0px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          backgroundColor: "#fff",
          padding: "10px 15px",
          borderBottom: "1px solid #ddd",
        }}
      >
        <RxCross2
          style={{ fontSize: "22px", cursor: "pointer", color: "#333" }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ padding: "20px" }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            {/* <Grid item xs={12}>
              <TextField
                variant="standard"
                select
                fullWidth
                name="reason_for_status_change"
                label="Offer Received"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.reason_for_status_change}
              >
                {offer_name.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              {formik.touched.reason_for_status_change &&
              formik.errors.reason_for_status_change ? (
                <div className={styles.error}>
                  {formik.errors.reason_for_status_change}
                </div>
              ) : null}
            </Grid> */}

            <Grid item xs={12}>
              <TextField
                variant="standard"
                fullWidth
                name="reason_for_status_change"
                label="Reason For Status Change"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.reason_for_status_change}
              />
              {formik.touched.reason_for_status_change &&
              formik.errors.reason_for_status_change ? (
                <div className={styles.error}>
                  {formik.errors.reason_for_status_change}
                </div>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="standard"
                fullWidth
                name="job_title"
                label="Job Role"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.job_title}
              />
              {formik.touched.job_title && formik.errors.job_title ? (
                <div className={styles.error}>{formik.errors.job_title}</div>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="standard"
                fullWidth
                type="number"
                name="duration"
                label="Duration"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.duration}
                InputLabelProps={{ shrink: true }}
              />
              {formik.touched.duration && formik.errors.duration ? (
                <div className={styles.error}>{formik.errors.duration}</div>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="standard"
                fullWidth
                name="recruiter_name"
                label="Recruiter Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.recruiter_name}
                InputLabelProps={{ shrink: true }}
              />
              {formik.touched.recruiter_name && formik.errors.recruiter_name ? (
                <div className={styles.error}>
                  {formik.errors.recruiter_name}
                </div>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="standard"
                fullWidth
                name="company"
                label="Company Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.company}
                InputLabelProps={{ shrink: true }}
              />
              {formik.touched.company && formik.errors.company ? (
                <div className={styles.error}>{formik.errors.company}</div>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                name="notes"
                label="Notes"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.notes}
              />
            </Grid>
          </Grid>
        </form>
        <Box mt={3} display="flex" justifyContent="space-between">
          <Button
            variant="contained"
            color="primary"
            onClick={formik.handleSubmit}
            type="submit"
            sx={{ borderRadius: "8px" }}
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            type="button"
            onClick={handleClose}
            sx={{ borderRadius: "8px" }}
          >
            Cancel
          </Button>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default StatusChangeDrawer;
